import { render, staticRenderFns } from "./TemplateButton.vue?vue&type=template&id=02973610&scoped=true"
import script from "./TemplateButton.vue?vue&type=script&lang=js"
export * from "./TemplateButton.vue?vue&type=script&lang=js"
import style0 from "./TemplateButton.vue?vue&type=style&index=0&id=02973610&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02973610",
  null
  
)

export default component.exports